import React, { ReactNode } from 'react';
import { SizeMe } from 'react-sizeme';

interface FlexibleLayoutProps {
  children: ReactNode[];
  widths: number[];
  components: {
    Card: ReactNode[];
  };
}

const FlexibleLayout: React.FC<FlexibleLayoutProps> = ({
  children, // 'Number of widths must match the number of children elements'
  widths
}) => {
  const widthsSpecified = widths && widths?.length > 0;
  return (
    <SizeMe monitorHeight monitorWidth>
      {({ size }) => {
        const { width } = size;
        const isLargeScreen = document?.documentElement?.clientWidth > 1900;

        return (
          <div className="flex fh fw">
            {children.map((child, index) => (
              <div
                key={index}
                className={`${!widthsSpecified &&
                  index === 0 &&
                  (isLargeScreen
                    ? 'mw-300 min-width-300'
                    : 'min-width-280 wm-280')} border-right fg1 flex-child fh fw overflow-x-auto overflow-y-hidden hideScrollBar`}
                style={widths && { flexBasis: `${widths[index]}%` }}
              >
                {child}
              </div>
            ))}
          </div>
        );
      }}
    </SizeMe>
  );
};

export default FlexibleLayout;
